var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupPersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_843)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_2135_843)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2135_843",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2135_843",
    transform: "scale(0.00833333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2135_843",
    width: 120,
    height: 120,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAABYlAAAWJQFJUiTwAAAEhklEQVR4nO3cIXsbNxwG8Pe/Z6DQ0PBgoWFZPRbWwbIahi37BOs+gfcN4rKxpGzMHjOLx8xiaDbDsHdAyhMvT2zdydKdzn5/pH1yPp3St9LpdJIBERERERERERERERERERERERERERERERERERERERHpC+u6AqUhWb360dbMnrqoSwoKGADJEYARgOrAR7YA1gBWZrZrq14pXHTAJN8DuAIwaHDaAsCyL636YgMmOQYwjjx9C+DPPrTmH7quQIeWcEHFGAK4Jtmk5XfiYgP2XewM8SG/A/CZ5LtklcrgYgMGkoQ8BPAhWYUy6GXAJEckpyTnJP/li0eSdyRv3njceZMP+R5A7KBpXHJX3atBlh8Y/Yb6g6MZgF/rDIZIfoAbUcdYmNki8tysetOCSU4BzNFs5DsB8Ejy59AHzWwJIHZU/D7yvOx6ETDJWwA3kacPANyRnNT47F+R1xiWOtgqPmAf7iRBUbehlmxma8S34mHkeVkVHbAPZJKwyNsaA6Jlwut1ruiAAUwTlzeoUeY68TU7VWzA/p5ZZSh6cuwRyo+4i5+CrKvYgAF8yVh2aFS9aVqgmTU+pw0lBzzOWPbHwPGmLXgTWY/sigzYT2jkNAocbzp1uYqtSG5FBtyCKnC8ybTlzswU8BmLnRxpxaUGnGqUvPKTI8UqNeDcXV6o/KpOGWZ2n6AuWRUZsH8WzRlyqOzQvPKyD+ECwI9dV+CI7wiPdmN9CxyvDvx8A/dqcJOyMjkV+z7YzzY9Zih6YWY/Ba791f/1Ce6RaQvXJceu/JC3kPzK9MZd/17ikRyQfEgYbuqXF3IqkhX/v+4q1m3Xv4sc4EM+pSUr3NLRdddN78mPrLEe65wVO4o+hG50PQHwCYcfo+4BfDezWYNyhzjy/NunR6N9vQt4H93ym/2Qoyb+6XYXXiE8wQG4ac4d3DPxDsCm5D1KvQ44NYa3kR7yHPi6tLlpBfwGfxsYI27J0BPcVOiyhJatgI/wQV8hfknsCm7mrLOgFXANPG0v8RNcyJ0sx1XANflR9mc0+zaAfWsA921/M0DxAe+NlEdw/7jPC+Zej6D3LfyfOwD/wA2AVqcuraHbnjJBfJe9BTBrM+QiA/aTEx/husXUrwwXAP6Ga00xj1Snhrxp8nx+qmIC9ve5L3Brltvab7uBezc8azKR4UO+Rnw9o/5zxeg8YN9af0HeddB1zAD8Xjdof0++jrzWzsz+iDy3kc6W7NDt0p8DuEP34QIve4mnrLFj37/8X0Rea1DnGil0EjDdvqMHlBHsazcAHvysVsgS8V/9cJ4B+1d3pb++qwDMGdg07kfDRW83bTVgurVOkzaveYIBgGmNllzsrgagxYD58gUqffL89Q8Hu1M/DVnsYrw2W3Dfwn1WIdzrbLLXIlIrAfsWMG7jWpl8Chzv/K3RIW214FwL2NsyDhwvtotuZaLD33/nbVwrFzPrfFIoRpF7kyQdBXzmFPCZU8BnTgGfubb2B68AHN2yKSIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIicun+A+Mu2OzmBpZ3AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPersonIcon);
export default __webpack_public_path__ + "static/media/group-person-icon.2d68e0f47d2983df9ba7c1db393bf406.svg";
export { ForwardRef as ReactComponent };